module.exports = {
  title: 'AI发型设计开发者平台',

  /**
   * @type {boolean} true | false
   * @description Whether need tagsView
   */
  tagsView: true,

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: true,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: true,

  /**
   * 官方配置
   */
  official: {
    email: 'common@tincent.me',
    phone: '15002910410'
  },

  /**
   * 外部页面
   */
  outerPage: {
    'home': '/',
    'login': '/?source=dev',
    'doc': 'https://docs.aihairstyle.cn',
    'priceDoc': 'https://docs.aihairstyle.cn/hairstyle-editor-pro/introduction',
    'errorCodeStrDoc': 'https://docs.aihairstyle.cn/essentials/errors'
  },

  /**
   * 处理记录错误码
   */
  aiCallRecordErrorCode: {
    'PROCESSING_FAILURE': '处理失败。',
    'ERROR_PARAMETERS': '无效参数。',
    'MISSING_PARAMETERS': '缺少参数。',
    'ERROR_INVALID_PARAMETER': '无效参数。',
    'PARAMETERS_CANNOT_EMPTY': '参数不能为空。',
    'ERROR_MISSING_LIMIT_PARAMETER': '缺少Limit参数。',
    'ERROR_MISSING_TASKS_PARAMETER': '缺少Tasks参数。',
    'ERROR_MISSING_ASSURE_DIRECTION_PARAMETER': '缺少AssureDirection参数。',
    'ERROR_MISSING_MIN_HEIGHT_PARAMETER': '缺少MinHeight参数。',
    'ERROR_INVALID_SIDE_PARAMETER': 'Side参数值无效。',
    'ERROR_TOO_MANY_FILES': '文件数量超出限制。',
    'ERROR_FACE_TRACE_LIMIT_EXCEEDED': '人脸或追踪限制超出。',
    'ERROR_INVALID_URL': '无效的URL。',
    'ERROR_DATABASE_LIMIT_EXCEEDED': '数据库限制超出。',
    'ERROR_INVALID_RESPONSE_FORMAT': '响应格式错误（不支持的Accept）。',
    'ERROR_UNSUPPORTED_RESPONSE_FORMAT': '响应格式错误（不支持的格式）。',
    'ERROR_TOO_MANY_GROUPS_IN_GROUP_LIST': 'group_list中组数过多。',
    'ERROR_TOO_MANY_UIDS_IN_UID_LIST': 'uid_list中UID数量过多。',
    'ERROR_TOO_MANY_APPS_IN_APP_LIST': 'app_list中应用数量过多。',
    'ERROR_BATCH_TASK_LIMIT_EXCEEDED': '批量任务处理限制超出。',
    'ERROR_CLEANING_USER_GROUP_DATA': '正在清理用户组数据。',
    'ERROR_IMAGE_STORAGE_NOT_SUPPORTED': '不支持图片存储。',
    'ERROR_INSUFFICIENT_RESOURCES': '资源不足。',
    'ERROR_RESOURCE_IN_TRANSIT': '资源传输中。',
    'ERROR_FILE_DOWNLOAD_FAILED': '文件下载失败。',
    'ERROR_FILE_UPLOAD_FAILED': '文件上传失败。',
    'FILE_DECODING_FAILURE': '文件解码失败。',
    'ERROR_FACE_BLENDING_FAILED': '人脸融合失败。',
    'ERROR_FACE_IMAGE_ADDITION_FAILED': '添加人脸图像失败。',
    'ERROR_GET_FACE_IMAGE_FAILED': '获取人脸图像失败。',
    'ERROR_DATA_TRANSFER_FAILED': '数据传输（下载或上传）失败。',
    'ERROR_TASK_REVOCATION_FAILED': '任务撤销失败。',
    'ERROR_RESOURCE_UNAVAILABLE': '资源暂时不可用。',
    'ERROR_FILE_DOWNLOAD_TIMEOUT': '文件下载超时。',
    'ERROR_USER_NOT_EXISTS': '用户不存在。',
    'ERROR_APPLICATIONS_NOT_EXISTS': '应用程序不存在。',
    'ERROR_USER_LOCKED': '用户已被锁定。',
    'AI_SERVICE_UNAUTHORIZED': 'AI服务未授权。请稍后重试，如未及时解决请联系平台。',
    'ERROR_ILLEGAL_FILE': '非法文件。',
    'ERROR_AI_NOT_EXISTS': 'AI不存在或已被停用，请联系平台。',
    'AI_SERVICE_NOT_FOUND': '找不到AI服务。请稍后重试，如未及时解决请联系平台。',
    'ERROR_FILE_NOT_FOUND': '找不到文件。',
    'ERROR_FACE_NOT_FOUND': '找不到人脸。',
    'ERROR_USER_GROUP_NOT_FOUND': '找不到用户组。',
    'ERROR_USER_NOT_FOUND': '找不到用户。',
    'ERROR_FACE_TOKEN_NOT_FOUND': '找不到人脸令牌。',
    'ERROR_CONTENT_NOT_FOUND': '找不到内容。',
    'ERROR_RESOURCE_NOT_FOUND': '找不到资源。',
    'ERROR_ILLEGAL_OPERATION': '非法操作。',
    'ERROR_FACE_ALREADY_EXISTS': '人脸已存在。',
    'ERROR_DATA_ALREADY_EXISTS': '数据已存在。',
    'ERROR_USER_GROUP_ALREADY_EXISTS': '用户组已存在。',
    'ERROR_USER_ALREADY_EXISTS': '用户已存在。',
    'ERROR_DUPLICATE_GROUP_NAME': '重复的组名。',
    'ERROR_RESOURCE_IN_USE': '资源正在使用中。',
    'ERROR_TASK_CONFLICT': '任务冲突。',
    'ERROR_TASK_REVOKED': '任务已被撤销。',
    'ERROR_RESOURCE_RECLAIMED': '资源已被回收。',
    'FILE_SIZE_EXCEEDS_LIMIT': '文件大小超出限制。',
    'ERROR_CONTENT_TOO_LONG': '内容长度超出限制。',
    'ERROR_VIDEO_DURATION_EXCEEDED': '视频时长超出限制。',
    'ERROR_REQUEST_BODY_TOO_LARGE': '请求体大小超出限制。',
    'ERROR_RESPONSE_BODY_TOO_LARGE': '响应体大小超出限制。',
    'UNSUPPORTED_FILE_TYPES': '不支持的文件类型。',
    'ERROR_INVALID_OUTPUT_FORMAT': '无效的输出格式。',
    'ERROR_UNSUPPORTED_GRAYSCALE_IMAGE': '不支持灰度图像。',
    'UNSUPPORTED_PARAMETER_VALUES': '不支持的参数值。',
    'ERROR_INVALID_FACE_BOX_PARAMETER': '人脸框参数不符合要求。',
    'ERROR_INVALID_BIG_EYES_PARAMETER': '大眼参数不符合要求。',
    'ERROR_INVALID_FACE_SLIMMING_PARAMETER': '瘦脸参数不符合要求。',
    'ERROR_INVALID_SMOOTHING_PARAMETER': '光滑参数不符合要求。',
    'ERROR_INVALID_SKIN_WHITENING_PARAMETER': '美白参数不符合要求。',
    'ERROR_INVALID_PARAMETER_FORMAT': '无效的参数格式。',
    'ERROR_PARAMETER_CONVERSION_FAILED': '参数转换失败。',
    'FILE_RESOLUTION_EXCEEDS_LIMITS': '文件分辨率超出限制。',
    'ERROR_LOW_RESOLUTION': '文件分辨率过低。',
    'ERROR_HIGH_RESOLUTION': '文件分辨率过高。',
    'ERROR_INVALID_FILE': '无效文件。',
    'FILE_CONTENT_NON_COMPLIANCE': '文件内容不符合要求。',
    'ERROR_INCORRECT_FILE_COUNT': '文件数量不正确。',
    'ERROR_NO_FACE_IN_FILE': '文件中未检测到人脸。',
    'ERROR_FACE_SIZE_NOT_MEET_REQUIREMENTS': '人脸大小不符合要求。',
    'ERROR_FACE_SIZE_RATIO_NOT_MET': '人脸大小比例不符合要求。',
    'ERROR_SMALL_FACE_SIZE': '人脸太小。',
    'ERROR_FACE_COPY_SCENE_MISMATCH': '人脸复制场景类型不匹配。',
    'ERROR_FACE_UNRECOGNIZABLE': '无法识别人脸。',
    'ERROR_POOR_FACE_QUALITY': '人脸质量差。',
    'ERROR_BLURRY_FACE': '人脸模糊。',
    'ERROR_OBSTRUCTED_FACE': '人脸被遮挡。',
    'ERROR_POOR_FACE_LIGHTING': '人脸光照不佳。',
    'ERROR_INCOMPLETE_FACE': '人脸不完整。',
    'ERROR_FACE_NOT_FACING_FORWARD': '人脸未正面朝向。',
    'ERROR_MISSING_OUTPUT_FORMAT': '缺少输出格式。',
    'ERROR_QUALITY_SCORE_NOT_MEET_REQUIREMENTS': '质量评分不符合要求。',
    'ERROR_QUALITY_CONTROL_ERROR': '质量控制错误。',
    'ERROR_LIVENESS_CONTROL_ERROR': '活体检测错误。',
    'ERROR_SCENE_TYPE_MISMATCH': '场景类型不匹配。',
    'ERROR_CARTOON_FACE_NOT_SUPPORTED': '不支持卡通人脸。',
    'ERROR_TEMPLATE_IMAGE_QUALITY_TOO_LOW': '模板图像质量过低。',
    'ERROR_ACTION_VERIFICATION_FAILED': '动作验证失败。',
    'ERROR_LEFT_EYE_OCCLUSION_TOO_HIGH': '左眼遮挡过高。',
    'ERROR_RIGHT_EYE_OCCLUSION_TOO_HIGH': '右眼遮挡过高。',
    'ERROR_LEFT_FACE_OCCLUSION_TOO_HIGH': '左脸遮挡过高。',
    'ERROR_RIGHT_FACE_OCCLUSION_TOO_HIGH': '右脸遮挡过高。',
    'ERROR_CHIN_OCCLUSION_TOO_HIGH': '下巴遮挡过高。',
    'ERROR_NOSE_OCCLUSION_TOO_HIGH': '鼻子遮挡过高。',
    'ERROR_MOUTH_OCCLUSION_TOO_HIGH': '嘴部遮挡过高。',
    'ERROR_SYNTHESIS_DETECTION_FAILED': '合成检测失败。',
    'ERROR_LIVENESS_DETECTION_FAILED': '活体检测失败。',
    'ERROR_NO_RECOGNITION_TARGET_DETECTED': '图像中未检测到识别目标。',
    'ERROR_IMAGE_RECOGNITION_FAILED': '图像识别错误。',
    'ERROR_MASK_IMAGE_RESOLUTION_MISMATCH': '`mask`和`image`的分辨率必须相同。',
    'ERROR_TASK_STOPPED_PROCESSING': '任务已停止处理。',
    'EXCEEDING_LIMITS': '超出限制。',
    'ERROR_CONTENT_NON_COMPLIANCE': '内容不符合要求。',
    'ERROR_NOT_ENOUGH_CREDITS': '积分不足。',
    'UNKNOWN_ERROR': '未知错误。请稍后重试，如未及时解决请联系平台。',
    'SERVICE_INTERNAL_ERROR': '服务内部错误。请稍后重试，如未及时解决请联系平台。',
    'FILE_SERVICE_ERROR': '文件服务错误。请稍后重试，如未及时解决请联系平台。',
    'AI_SERVICE_ERROR': 'AI服务错误。请稍后重试，如未及时解决请联系平台。',
    'AI_SERVICE_INTERNAL_ERROR': 'AI服务内部错误。请稍后重试，如未及时解决请联系平台。',
    'ERROR_GATEWAY': '网关错误，请稍后重试。如未及时解决请联系平台。',
    'AI_SERVICE_FLOW_RESTRICTION': 'AI服务限流。请稍后重试，如未及时解决请联系平台。',
    'AI_SERVICE_TIMEOUT': 'AI服务超时。请稍后重试，如未及时解决请联系平台。'
  },

  /**
   * 阿里云设备风险识别
   */
  aliyunFP: {
    appKey: 'shc99bf597hse96ba35665f2e240d240',
    appName: 'AI发型设计开发者平台',
    endpoints: [
      'https://cloudauth-device.aliyuncs.com',
      'https://cloudauth-device.ap-southeast-1.aliyuncs.com'
    ]
  }

}
